// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FN752iUGxxMOsDgnf1Zq{width:30px;height:28px}html[dir=ltr] .FN752iUGxxMOsDgnf1Zq{margin-left:20px}html[dir=rtl] .FN752iUGxxMOsDgnf1Zq{margin-right:20px}.E20Ip_MoM1Fl3MPje2ys{display:table-row}.okxbhm3Fs_w9y0G0zgpm{display:table-cell}html[dir] .okxbhm3Fs_w9y0G0zgpm{padding-bottom:4px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"numInput": "FN752iUGxxMOsDgnf1Zq",
	"insertTableDialogRow": "E20Ip_MoM1Fl3MPje2ys",
	"insertTableDialogCell": "okxbhm3Fs_w9y0G0zgpm"
};
module.exports = ___CSS_LOADER_EXPORT___;
